<ion-list>
  <ion-item *ngFor="let opt of _options">
    <ion-label>
      <strong>{{opt.display}}</strong>
      <p *ngIf="opt.description">{{opt.description}}</p>
    </ion-label>
    <ion-checkbox slot="start" [(ngModel)]="exportOptionsHelper.exportOptions[opt.key]"></ion-checkbox>
  </ion-item>
</ion-list>